export default class Buttons {
	constructor() {
		this.buttons = document.querySelectorAll(".btn, .btn-small");

		this.buttons.forEach((button) => {
            if (button.querySelector('.label')) {
                return; // Passer au bouton suivant
            }

			const text = `<span class='label'>${button.innerHTML}</span>`;
			button.innerHTML = text;

			if (button.classList.contains('btn-go') || button.classList.contains('btn-back')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.93495 5.06703L5.27991 9.93232L5.21549 10L5.15231 9.93232L4.49052 9.23446L4.4261 9.16678L4.49052 9.10041L7.85326 5.58483L0.0906987 5.58615L0 5.58681L0.000625486 5.49152L0.000625599 4.50848L3.93338e-08 4.4132L0.0906987 4.41385H7.85326L4.49052 0.899593L4.4261 0.833224L4.49052 0.765541L5.15231 0.067683L5.21549 0L5.27991 0.067683L9.93495 4.93297L10 5L9.93495 5.06703Z" fill="currentColor"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-download')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.51223 5.64288L0.5 6.63552L7.5 13.5L14.5 6.63552L13.488 5.64288L8.21598 10.8129L8.21598 0.5L6.78441 0.5L6.78441 10.8129L1.51223 5.64288Z"/>
<path d="M2 15H13V16H2V15Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

            if (button.classList.contains('btn-reset')) {
                const element = document.createElement("span");
                element.innerHTML = `<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 0.838801L4.83788 3.99949L7.93104 7.09224L8 7.16017L7.93104 7.2281L7.228 7.93104L7.16006 8L7.09213 7.93104L4 4.83829L0.907874 7.93104L0.840968 8L0.773031 7.93104L0.0689655 7.2281L0 7.16017L0.0689655 7.09224L3.16109 3.99949L0 0.838801L0.838909 0L4 3.16068L7.16212 0L8 0.838801Z" fill="currentColor"/>
</svg>`;
                element.classList.add('svg');
                button.appendChild(element);
            }

			if (button.classList.contains('btn-lang')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}
		});
	}
}
